/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Home_Historicallows_Openoffer2Inputs */

const en_us2_home_historicallows_openoffer2 = /** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open offer ${i?.title}`)
};

const es_es2_home_historicallows_openoffer2 = /** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir oferta ${i?.title}`)
};

const ru_home_historicallows_openoffer2 = /** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Открыть предложение ${i?.title}`)
};

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const id_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const ms_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const da_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const de_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const es_mx2_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const fil_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const fr_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const it_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const hu_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const nl_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const no_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const pl_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const pt_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const pt_br2_home_historicallows_openoffer2 = pt_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const ro_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const fi_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const sv_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const vi_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const tr_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const cs_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const bg_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const uk_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const ar_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const hi_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const th_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const ja_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const zh_cn2_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const zh_hant1_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/** @type {(inputs: Home_Historicallows_Openoffer2Inputs) => LocalizedString} */
const ko_home_historicallows_openoffer2 = en_us2_home_historicallows_openoffer2;

/**
* | output |
* | --- |
* | "Open offer {title}" |
*
* @param {Home_Historicallows_Openoffer2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_historicallows_openoffer2 = /** @type {((inputs: Home_Historicallows_Openoffer2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Historicallows_Openoffer2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_historicallows_openoffer2(inputs)
	if (locale === "ms") return ms_home_historicallows_openoffer2(inputs)
	if (locale === "da") return da_home_historicallows_openoffer2(inputs)
	if (locale === "de") return de_home_historicallows_openoffer2(inputs)
	if (locale === "en-US") return en_us2_home_historicallows_openoffer2(inputs)
	if (locale === "es-ES") return es_es2_home_historicallows_openoffer2(inputs)
	if (locale === "es-MX") return es_mx2_home_historicallows_openoffer2(inputs)
	if (locale === "fil") return fil_home_historicallows_openoffer2(inputs)
	if (locale === "fr") return fr_home_historicallows_openoffer2(inputs)
	if (locale === "it") return it_home_historicallows_openoffer2(inputs)
	if (locale === "hu") return hu_home_historicallows_openoffer2(inputs)
	if (locale === "nl") return nl_home_historicallows_openoffer2(inputs)
	if (locale === "no") return no_home_historicallows_openoffer2(inputs)
	if (locale === "pl") return pl_home_historicallows_openoffer2(inputs)
	if (locale === "pt-BR") return pt_br2_home_historicallows_openoffer2(inputs)
	if (locale === "pt") return pt_home_historicallows_openoffer2(inputs)
	if (locale === "ro") return ro_home_historicallows_openoffer2(inputs)
	if (locale === "fi") return fi_home_historicallows_openoffer2(inputs)
	if (locale === "sv") return sv_home_historicallows_openoffer2(inputs)
	if (locale === "vi") return vi_home_historicallows_openoffer2(inputs)
	if (locale === "tr") return tr_home_historicallows_openoffer2(inputs)
	if (locale === "cs") return cs_home_historicallows_openoffer2(inputs)
	if (locale === "bg") return bg_home_historicallows_openoffer2(inputs)
	if (locale === "ru") return ru_home_historicallows_openoffer2(inputs)
	if (locale === "uk") return uk_home_historicallows_openoffer2(inputs)
	if (locale === "ar") return ar_home_historicallows_openoffer2(inputs)
	if (locale === "hi") return hi_home_historicallows_openoffer2(inputs)
	if (locale === "th") return th_home_historicallows_openoffer2(inputs)
	if (locale === "ja") return ja_home_historicallows_openoffer2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_historicallows_openoffer2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_historicallows_openoffer2(inputs)
	return ko_home_historicallows_openoffer2(inputs)
});
export { home_historicallows_openoffer2 as "home.historicalLows.openOffer" }